import { SEARCH_PLACEHOLDER } from '../../constants';

interface HeaderSearchProps {
  placeholder?: string;
  /** Disabled until there is a search endpoint to submit to. */
  disabled?: boolean;
}

/**
 * The comp renders this as a styled <p>. A real input means wiring it up later
 * is a one-line change; `disabled` keeps users from typing into a dead box.
 */
export function HeaderSearch({
  placeholder = SEARCH_PLACEHOLDER,
  disabled = true,
}: HeaderSearchProps) {
  return (
    <div className="header__search">
      <i className="pi pi-search header__search-icon" aria-hidden="true" />
      <input
        className="header__search-input"
        type="search"
        placeholder={placeholder}
        disabled={disabled}
        aria-label={disabled ? 'Search (coming soon)' : 'Search'}
        title={disabled ? 'Search coming soon' : undefined}
      />
    </div>
  );
}
